import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function FaceID({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M1.21875 6.58594V3.89063C1.21875 2.41734 2.41737 1.21875 3.89063 1.21875H6.58594C6.92248 1.21875 7.19531 0.945914 7.19531 0.609375C7.19531 0.272836 6.92248 0 6.58594 0H3.89063C1.74534 0 0 1.74532 0 3.89063V6.58594C0 6.92248 0.272836 7.19531 0.609375 7.19531C0.945914 7.19531 1.21875 6.92248 1.21875 6.58594Z"
        fill={iconColor}
      />
      <Path
        d="M6.58594 22.7813C6.92248 22.7813 7.19531 23.0541 7.19531 23.3906C7.19531 23.7272 6.92248 24 6.58594 24H3.89063C1.74534 24 0 22.2547 0 20.1094V17.4141C0 17.0775 0.272836 16.8047 0.609375 16.8047C0.945914 16.8047 1.21875 17.0775 1.21875 17.4141V20.1094C1.21875 21.5826 2.41737 22.7813 3.89063 22.7813H6.58594Z"
        fill={iconColor}
      />
      <Path
        d="M24 17.4141V20.1094C24 22.2547 22.2547 24 20.1094 24H17.4141C17.0775 24 16.8047 23.7272 16.8047 23.3906C16.8047 23.0541 17.0775 22.7813 17.4141 22.7813H20.1094C21.5826 22.7813 22.7813 21.5826 22.7813 20.1094V17.4141C22.7813 17.0775 23.0541 16.8047 23.3906 16.8047C23.7272 16.8047 24 17.0775 24 17.4141Z"
        fill={iconColor}
      />
      <Path
        d="M24 3.89063V6.58594C24 6.92248 23.7272 7.19531 23.3906 7.19531C23.0541 7.19531 22.7813 6.92248 22.7813 6.58594V3.89063C22.7813 2.41734 21.5826 1.21875 20.1094 1.21875H17.4141C17.0775 1.21875 16.8047 0.945914 16.8047 0.609375C16.8047 0.272836 17.0775 0 17.4141 0H20.1094C22.2547 0 24 1.74532 24 3.89063Z"
        fill={iconColor}
      />
      <Path
        d="M16.2053 17.7383C16.462 17.5012 16.4779 17.1008 16.2408 16.8441C16.0036 16.5873 15.6033 16.5715 15.3465 16.8086C14.433 17.6524 13.2445 18.1171 11.9999 18.1171C10.7554 18.1171 9.56687 17.6524 8.65335 16.8086C8.39657 16.5715 7.99628 16.5874 7.75911 16.8441C7.52197 17.1008 7.53784 17.5012 7.79457 17.7383C8.94266 18.7987 10.4361 19.3828 11.9999 19.3828C13.5638 19.3828 15.0572 18.7987 16.2053 17.7383Z"
        fill={iconColor}
      />
      <Path
        d="M13.2656 9.04688V13.5469C13.2656 14.4386 12.5402 15.1641 11.6484 15.1641H11.1328C10.7833 15.1641 10.5 14.8808 10.5 14.5313C10.5 14.1818 10.7833 13.8984 11.1328 13.8984H11.6484C11.8423 13.8984 12 13.7407 12 13.5469V9.04688C12 8.69738 12.2833 8.41406 12.6328 8.41406C12.9823 8.41406 13.2656 8.69738 13.2656 9.04688Z"
        fill={iconColor}
      />
      <Path
        d="M17.625 10.8164V9.01172C17.625 8.68165 17.3574 8.41406 17.0273 8.41406C16.6973 8.41406 16.4297 8.68165 16.4297 9.01172V10.8164C16.4297 11.1465 16.6973 11.4141 17.0273 11.4141C17.3574 11.4141 17.625 11.1465 17.625 10.8164Z"
        fill={iconColor}
      />
      <Path
        d="M6.51563 10.8164C6.51563 11.1465 6.78321 11.4141 7.11328 11.4141C7.44335 11.4141 7.71094 11.1465 7.71094 10.8164V9.01172C7.71094 8.68165 7.44335 8.41406 7.11328 8.41406C6.78321 8.41406 6.51563 8.68165 6.51563 9.01172V10.8164Z"
        fill={iconColor}
      />
    </Svg>
  );
}
